// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import { awsuiPluginsInternal } from '../plugins/api';
const AppLayoutWidgetSplitPanelContext = awsuiPluginsInternal.sharedReactContexts.createContext(React, 'AppLayoutWidgetSplitPanelContext');
export const SplitPanelContextProvider = AppLayoutWidgetSplitPanelContext.Provider;
export function useSplitPanelContext() {
    const ctx = useContext(AppLayoutWidgetSplitPanelContext);
    if (!ctx) {
        throw new Error('Split panel can only be used inside app layout');
    }
    return ctx;
}
//# sourceMappingURL=split-panel-context.js.map